import component from './ct-radio'

const com = {
  install (Vue) {
    Vue.component('CTRadio', component)
  }
}
export default com
